import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import FlowList from './Index.vue';
import FlowEditor from './FlowEditor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flow-builder'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'flow_builder_list',
          component: FlowList,
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/flow-builder'),
      component: SettingsWrapper,
      children: [
        {
          path: ':flowId/edit',
          name: 'flow_builder_edit',
          component: FlowEditor,
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
            fullWidth: true,
          },
        },
        {
          path: 'new',
          name: 'flow_builder_new',
          component: FlowEditor,
          meta: {
            permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
            fullWidth: true,
          },
        },
      ],
    },
  ],
};
